import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { usePlayer } from '../../../player';
import { Title } from '../Title';
import type { TrackInfoContentProps } from '../TrackInfoContent';
import { Author } from './Author';

type PlayerTrackInfoProps = Omit<TrackInfoContentProps, 'isVisible'>;

export function PlayerTrackInfo({
  titleTextStyle,
  authorTextStyle,
  wrapTitle,
  track,
  disableTicker
}: PlayerTrackInfoProps) {
  const { currentItem } = usePlayer();
  const derivedTrack = track ?? currentItem;

  return (
    <Container>
      <Title textStyle={titleTextStyle} wrap={wrapTitle} track={derivedTrack} />

      <Author
        textStyle={authorTextStyle}
        track={derivedTrack}
        disableTicker={disableTicker}
      />
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'players-track-info',
    element: 'container'
  })
})`
  width: fit-content;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
